import { getPermissionList } from "./checkMenuPermission.js";
import "./logVersion.js";
import "../axios/selfAxios.js";
import "./opGetProductionByIds.js";
import "../qiankun/action.js";
import "./bodySize.js";
import "vue-demi";
import "./getActivityLabel.js";
import "./getDict.js";
import { reqGetCurrentUser } from "../request/ucenterapi/uc/internal/common/getCurrentUser/get.js";
import "axios-interceptor";
import "lodash-es";
import "js-base64";
import "jszip";
import "./windowSize.js";
import "./currentUserIsGroup.js";
import "./opPostBatchQueryActivityTypeByCondition.js";
import "./getShowConfigButton.js";
import "./checkResponseType.js";
import "qrcode";
import "../external/type.js";
import "../external/kujiale/initKujiale.js";
function routeInterceptorCheckPermissionFactory(arg) {
  const { noPermissionNextParams, platformType = "MTDS" } = arg;
  return async (to, from, next) => {
    const { meta } = to;
    let hasPermission = true;
    if (meta && (meta.permissionsButton || meta.permissionsUserType)) {
      if (hasPermission && meta.permissionsButton) {
        const permissionList = await getPermissionList(platformType);
        hasPermission = permissionList.some((p) => meta.permissionsButton.some((e) => {
          const keys = Object.keys(e);
          return keys.every((k) => e[k] === p[k]);
        }));
      }
      if (hasPermission && meta.permissionsUserType) {
        const user = await reqGetCurrentUser();
        if (meta.permissionsUserType === "shop") {
          hasPermission = user.orgId !== "1";
        }
        if (meta.permissionsUserType === "oppein") {
          hasPermission = user.orgId === "1";
        }
      }
    }
    if (hasPermission) {
      next();
    } else {
      next(noPermissionNextParams);
    }
  };
}
export { routeInterceptorCheckPermissionFactory };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/routeInterceptorCheckPermissionFactory.js